import { render, staticRenderFns } from "./ChecksModal.vue?vue&type=template&id=4b8993ab&scoped=true&"
import script from "./ChecksModal.vue?vue&type=script&lang=js&"
export * from "./ChecksModal.vue?vue&type=script&lang=js&"
import style0 from "./ChecksModal.vue?vue&type=style&index=0&id=4b8993ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8993ab",
  null
  
)

export default component.exports